import { Spinner as UiSpinner } from '../../ui'

interface SpinnerProps {
    text?: string
}

/** Legacy block spinner. New code should use `Spinner` from `ui`. */
export const Spinner = ({ text = 'Loading data...' }: SpinnerProps) => <UiSpinner block size="md" text={text} />
